<template>
  <el-tabs>
    <el-tab-pane lazy label="接口权限">
      <actions :mode="mode" :target="target" />
    </el-tab-pane>
    <el-tab-pane lazy label="导航权限">
      <modules :mode="mode" :target="target" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  components: {
    actions: () => import("./action/list.vue"),
    modules: () => import("./module.vue"),
  },
  data() {
    return {
      mode: this.$route.params?.mode,
      target: this.$route.params?.id,
    };
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-tabs) {
  height: 100%;
  display: flex;
  flex-direction: column;
  &__content {
    flex: 1;
    .el-tab-pane {
      height: 100%;
    }
  }
}
</style>